import FormInput from "@/components/forms/FormInput";
import FormSelect from "@/components/forms/FormSelect";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { useCreateSuggestedSearchMutation } from "@/app/features/suggestedSearch/suggestedSearchApiSlice";

const initialValues = {
  searchType: "global",
  label: "",
  searchQuery: "",
  sortOrder: 0,
  isActive: "true",
};

const validationSchema = Yup.object().shape({
  searchType: Yup.string().oneOf(["global", "ai"]).required().label("Type"),
  label: Yup.string().required().max(100).label("Label").trim(),
  searchQuery: Yup.string().required().max(200).label("Search query").trim(),
  sortOrder: Yup.number().min(0).label("Sort order"),
  isActive: Yup.string().required().label("Active"),
});

const typeItems = [
  { name: "Global search (header + /search page)", code: "global" },
  { name: "AI search (Find a Car)", code: "ai" },
];

const activeItems = [
  { name: "Yes", code: "true" },
  { name: "No", code: "false" },
];

export default function CreateSuggestedSearchPage() {
  const [createSuggestedSearch, { isLoading }] =
    useCreateSuggestedSearchMutation();
  const navigate = useNavigate();

  const handleSubmit = async (inputs) => {
    try {
      const result = await createSuggestedSearch({
        searchType: inputs.searchType,
        label: inputs.label.trim(),
        searchQuery: inputs.searchQuery.trim(),
        sortOrder: Number(inputs.sortOrder) || 0,
        isActive: inputs.isActive === "true",
      });

      if (result?.data) {
        toast.success(result.data.message);
        navigate("/suggested-search");
      } else if (result?.error) {
        toast.error(result.error?.data?.message || "Failed to create");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4">Create Suggested Search</Typography>
            <Typography color="text.secondary" sx={{ mt: 1 }}>
              Choose Global or AI. Max 6 active items per type.
            </Typography>
          </Box>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {() => (
              <Form>
                <Stack spacing={3}>
                  <FormSelect
                    label="Search type"
                    name="searchType"
                    items={typeItems}
                  />
                  <FormInput
                    label="Label (shown in dropdown)"
                    name="label"
                    type="text"
                    placeholder="e.g. Electric SUV"
                  />
                  <FormInput
                    label="Search query (used when clicked)"
                    name="searchQuery"
                    type="text"
                    placeholder="e.g. Electric SUV"
                  />
                  <FormInput
                    label="Sort order (lower = first)"
                    name="sortOrder"
                    type="number"
                    placeholder="0"
                  />
                  <FormSelect label="Active" name="isActive" items={activeItems} />
                  <Button type="submit" variant="contained" disabled={isLoading}>
                    Submit
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </Container>
    </Box>
  );
}
